"use client";

import { lazy } from "react";

// Single lazy() call site for the newsletter form, rendered by both the footer
// ribbon and the signup modal (each behind its own Suspense fallback). A second
// async boundary over the same form modules makes the bundler hoist Formik and
// the form components into the eager route chunks on every page.
export const LazyNewsletterSignup = lazy(() =>
    import("./NewsletterSignup").then((module) => ({ default: module.NewsletterSignup }))
);
